import { useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import {
  toDonationRequisitionFilterSearch,
  toDonationRequisitionFilterValues,
} from '../utils/mpFilters';

const route = getRouteApi('/_auth/market-promotion/requisitions');

const normalizeFilterValues = (values: Record<string, string>) =>
  toDonationRequisitionFilterValues(toDonationRequisitionFilterSearch(values));

export function useDonationRequisitionFilters() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const appliedValues = useMemo(() => toDonationRequisitionFilterValues(search), [search]);

  const filters = useUrlSyncedFilters({
    appliedValues,
    normalizeValues: normalizeFilterValues,
    onApply: (values) => {
      void navigate({
        search: (previous) => ({ ...previous, ...toDonationRequisitionFilterSearch(values) }),
        replace: true,
      });
    },
  });

  return { ...filters, search };
}
